import React from 'react';
import { LoaderWrapper, Spinner } from './styles';

const Loader: React.FC = () => {
  return (
    <LoaderWrapper>
      <Spinner />
    </LoaderWrapper>
  );
};

export default Loader;